export default __webpack_public_path__ + "static/media/usersIcon.73061ad8.svg";